(function () {
  if (!window.location.search) return;

  var PARAM_TO_ARRAY = {
    magnet_type: 'arrMagnetType',
    output_level: 'arrOutputLevel',
    pickup_type: 'arrPickupType',
    position: 'arrPosition',
    style_character: 'arrStyleCharacter',
    effect_type: 'arrEffectType',
    fx_card_type: 'arrCardType',
    product_type: 'arrProductType',
    string_count: 'arrStringCount',
    orientation: 'arrOrientation',
    scale_type: 'arrScaleType',
    active_passive: 'arrActivePassive',
    cover_compatibility: 'arrCoverCompatibility',
    sales_format: 'arrSalesFormat',
    module_scenario: 'arrModuleScenario',
    body_type_ids: 'arrBodyTypes',
    series: 'arrSeries',
    color_ids: 'arrColors',
    back_wood_ids: 'arrBackWoods',
    top_wood_ids: 'arrTopWoods',
    finish_ids: 'arrFinishes',
    body_fret_ids: 'arrBodyFret',
    headstock_ids: 'arrHeadstocks',
    neck_wood_ids: 'arrNeckWoods',
    fretboard_wood_ids: 'arrFretBoardWoods',
    neck_fret_ids: 'arrFretCount',
    scale_length_ids: 'arrScaleLength',
    radius_nut_ids: 'arrRadiusNut',
    radius_last_ids: 'arrRadiusLast',
    inlay_ids: 'arrInlays',
    neck_color_ids: 'arrNeckColors'
  };

  dmx.nextTick(function () {
    dmx.nextTick(function () {
      var params = new URLSearchParams(window.location.search);
      Object.keys(PARAM_TO_ARRAY).forEach(function (param) {
        var val = params.get(param);
        if (val) {
          val.split(',').forEach(function (v) {
            if (v) dmx.parse('view1.' + PARAM_TO_ARRAY[param] + '.addUniq(' + JSON.stringify(v) + ')');
          });
        }
      });
    });
  });
})();